import PageNotFound from '../../features/fallbacks/404'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'

const PageNotFoundContainer: React.FC<RouteComponentProps> = (props) => <PageNotFound {...props} />

export default PageNotFoundContainer
